import createHTMLMapMarker from "../elements/overlayMarker.js";

const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export default {

    methods: {
      addMarkers: function () {

        var promises = [];

        if (isLocalDev) {
          console.group('[Map Debug] Adding markers');
          console.log(`Total markers to add: ${this.vm.markers?.length || 0}`);
          console.log('Markers data:', this.vm.markers);
        }

        if (!this.vm.markers || this.vm.markers.length === 0) {
          if (isLocalDev) {
            console.warn('[Map Debug] No markers found in vm.markers');
            console.groupEnd();
          }
          return;
        }

        this.vm.markers.forEach((marker, index) => {
          if (isLocalDev) {
            console.log(`[Map Debug] Processing marker ${index + 1}:`, {
              development: marker.development,
              developmentSlug: marker.developmentSlug,
              backgroundTheme: marker.backgroundTheme,
              position: marker.position,
              propertyCount: marker.propertyCount
            });
          }
          promises.push(this.addMarker(marker, index));
        });

        Promise.all(promises).then(() => {
          if (isLocalDev) {
            console.log(`[Map Debug] All ${promises.length} markers added successfully`);
            console.groupEnd();
          }
          this.addZoomLimit();
          this.fitAndPanToBounds();
        }).catch((error) => {
          if (isLocalDev) {
            console.error('[Map Debug] Error adding markers:', error);
            console.groupEnd();
          }
        });

      },
      addMarker: function(marker, index = 0) {
        try {
          // Validate marker position
          if (!marker.position || typeof marker.position.lat !== 'number' || typeof marker.position.lng !== 'number') {
            if (isLocalDev) {
              console.error(`[Map Debug] Marker ${index + 1} has invalid position:`, marker.position);
            }
            return Promise.reject(new Error(`Invalid marker position for marker ${index + 1}`));
          }

          const latLng = new google.maps.LatLng(
            marker.position.lat,
            marker.position.lng
          );

          // Note: CSS handles the fill color via --map__icon-fill variable, so we use the same SVG
          const markerIconName = 'map-marker';
          const markerName = marker.development || marker.developmentSlug || `marker-${index + 1}`;

          if (isLocalDev) {
            console.log(`[Map Debug] Marker ${index + 1} "${markerName}":`, {
              icon: markerIconName,
              theme: marker.backgroundTheme || 'default',
              lat: marker.position.lat,
              lng: marker.position.lng,
              propertyCount: marker.propertyCount
            });
          }

          let markerElement = createHTMLMapMarker({
            latlng: latLng,
            map: this.map.instance,
            title: markerName,
            html: `<button class="map__marker__button ${marker.propertyCount == 0 ? 'map__marker__button--zero' : ''}${marker.backgroundTheme != undefined ? ` map__marker__button--bg-${marker.backgroundTheme}` : ''}" aria-label="View ${marker.propertyCount} ${markerName} properties" title="${markerName}" data-marker-name="${markerName}" data-marker-theme="${marker.backgroundTheme || 'default'}">
                    <svg class="map__marker__icon" aria-hidden="true">
                      <use xlink:href="/spritemap.svg#${markerIconName}"></use>
                    </svg>
                    <svg class="map__marker__logo" aria-hidden="true">
                      <use xlink:href="/spritemap.svg#northern-logo-icon"></use>
                    </svg>
                    <span class="map__marker__count">${marker.propertyCount}</span>
                  </button>
                  <div class="map__marker__text">
                    ${this.vm.development ? '<h3 class="map__marker__title">${marker.development}</h3>' : ''}
                    ${this.vm.linkTitle ?
                      `<span class="map__marker__link-text" aria-hidden="true">
                        ${this.vm.linkTitle}
                        <svg class="map__marker__link-text__icon" aria-hidden="true">
                          <use xlink:href="/spritemap.svg#arrow--stroke"></use>
                        </svg>
                      </span>`
                      : ''
                    }
                  </div>`,
          });
          google.maps.event.addListener(markerElement, 'click', () => {
            this.unSelectAllMarkers();
            markerElement.makeActive();
            this.map.instance.panTo(markerElement.getPosition());
            this.selectDevelopment(marker.developmentSlug);
          });
          this.map.markerElements.push(markerElement);
          this.map.bounds.extend(latLng);

          return Promise.resolve();
        } catch (error) {
          if (isLocalDev) {
            console.error(`[Map Debug] Error adding marker ${index + 1}:`, error, marker);
          }
          return Promise.reject(error);
        }
      },
      unSelectAllMarkers: function(fitToBounds) {
        this.map.markerElements.forEach((markerElement) => { markerElement.removeActive() });
        if(fitToBounds) {
          this.fitAndPanToBounds();
        }
      },
      selectDevelopment: function(developmentSlug) {
        this.$emit("select-development", developmentSlug);
      },
      fitAndPanToBounds: function() {
        this.map.instance.fitBounds(this.map.bounds, 60);
        this.map.instance.panToBounds(this.map.bounds);
      },
      addZoomLimit: function () {
        let map = this.map.instance;
        let markerCount = this.map.markerElements.length;
  
        google.maps.event.addListenerOnce(map, 'zoom_changed', function () {
          google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
            let maxZoom = 16;
            if (markerCount > 1) maxZoom = 17;
            if (map.getZoom() > maxZoom && map.initialZoom == true) {
              map.setZoom(maxZoom);
              map.initialZoom = false;
            }
          });
        });
        this.map.instance.initialZoom = true;
      }
    }
  }